module.exports = __webpack_public_path__ + "media/images/shared/logotypes/logo_robertsfors-b340cc4692b821692bbcfffdc5a28960.png";